import { render, staticRenderFns } from "./DashGaugeChart.vue?vue&type=template&id=63fee892&"
import script from "./DashGaugeChart.vue?vue&type=script&lang=js&"
export * from "./DashGaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports